<template>
  <v-dialog v-model="open" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>


            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Name"
                v-model="item.name"
                :rules="validators.site.name"
                :readonly="!$can('upsert', 'site')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm2 md2>
               <v-text-field
                label="Country Code"
                v-model="item.country_code"
                :rules="validators.site.country"
                :readonly="!$can('upsert', 'site')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm7 md7>
              <v-text-field
                label="City"
                v-model="item.city"
                :rules="validators.site.city"
                :readonly="!$can('upsert', 'site')"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm3 md3>
              <v-text-field
                label="Code"
                v-model="item.code"
                :rules="validators.site.code"
                :readonly="!$can('upsert', 'site')"
              ></v-text-field>
            </v-flex>

          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          v-if="$can('upsert', 'site')"
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!validForm"
          @click="save()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/site";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  data() {
    return {
      validForm: true,
      validators,
      countries: ['IT']
    };
  },
  mounted() {
  },
  watch: {
    open() {
      if (this.isNew) {
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    open() {
      return this.$store.getters.siteDialog;
    },
    item: {
      get() {
        return this.$store.getters.siteItem;
      },
      set() {}
    },
    protocols() {
      return this.$store.getters.protocols;
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Site" : "Edit Site";
    }
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then(data => {
        const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
        this.$store.commit("app/siteItem", newItem);
      });
    },
    close() {
      this.$store.dispatch("app/closeSiteDialog");
    },
    checkSave() {
      return !this.isNew
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Site updated correctly",
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$store.commit("app/siteItem", newItem);
          this.$root.$emit('updateSites', newItem);
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Site update. " +
              e.response.data.message,
            color: "error"
          });
        });
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
